import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Auth = lazy(() => import("@/pages/Auth"));

export const Route = createFileRoute("/logga-in")({
  head: () => seoHead("/logga-in"),
  component: () => <Auth />,
});
